import { useState } from 'react';
import { Tabs, Tab, Box, Button, Grid, Typography } from '@mui/material';

import EventsDashboard from './events/EventsDashboard';
import UsersDashboard from './users/UsersDashboard';

const Dashboard = () => {

    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const dashboards = {
        0: <EventsDashboard />,
        1: <UsersDashboard />,
    }

    const Dashboard = dashboards[value];

    // =========================================

    return (

        <Grid container spacing={2}>

            <Grid size={12}>

                <Tabs 
                    value={value} 
                    onChange={handleChange} 
                    aria-label="basic tabs example"
                >
                    <Tab label="Events"/>
                    <Tab label="Users"/>
                </Tabs>

            </Grid>

            <Grid size={12}>    

                {Dashboard}

            </Grid>

        </Grid>

    )

}

export default Dashboard